/**
 * #106: user-selected AI provider ("source"), persisted in browser localStorage.
 * When set to a concrete provider it's attached as the `X-LLM-Provider` header
 * (see services/chatapi.js) and the backend uses it to override the server-
 * configured provider for that request. Empty string => use the server default.
 *
 * Pairs with the user's own key (utils/llmApiKey.js, `X-LLM-API-Key`).
 */
const STORAGE_KEY = 'ai_provider';

// The providers a user can pick from the UI. '' = server default (no override).
export const AI_PROVIDERS = [
  { id: '', label: 'Server default' },
  { id: 'github_models', label: 'GitHub Models' },
  { id: 'openrouter', label: 'OpenRouter' },
];

export const AI_PROVIDER_CHANGED_EVENT = 'ai-provider-changed';

export function getAiProvider() {
  try {
    return (typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY)) || '';
  } catch {
    return '';
  }
}

export function setAiProvider(provider) {
  try {
    if (provider) window.localStorage.setItem(STORAGE_KEY, provider);
    else window.localStorage.removeItem(STORAGE_KEY);
    // Notify listeners (e.g. the model dropdown) to re-fetch for the new provider.
    if (typeof window !== 'undefined' && window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent(AI_PROVIDER_CHANGED_EVENT, { detail: provider }));
    }
  } catch { /* localStorage unavailable */ }
}
